import { useQuery } from '@tanstack/react-query';
import { useAuth } from './useAuth';
import { getLiberiaCurrentUserRoles } from '@/utils/liberiaApi';

export type UserRole = 'qls_admin' | 'admin' | 'partner' | 'user' | 'business' | 'surveyor' | 'law_enforcement' | 'ems' | 
  'fire_department' | 'disaster_management' | 'utility_management' | 'utility_service_owner' | 'utility_service_agent' | 'road_infrastructure' | 
  'waste_management' | 'waste_service_owner' | 'waste_service_agent' | 'tax_revenue' | 'census_statistics' | 'permit_licensing' | 
  'property_management' | 'real_estate' | 'delivery_logistics' | 'delivery_service_owner' | 'delivery_service_agent' | 'tourism_hospitality' | 
  'education_services' | 'health_services' | 'social_services' | 'business_registration_admin' | 'taxpayer' | 'vendor_admin';

export interface UserRoleAccess {
  role: UserRole;
  leRoles?: string[];
  emsRoles?: string[];
  fireRoles?: string[];
  disasterRoles?: string[];
  utilityRoles?: string[];
  roadRoles?: string[];
  wasteRoles?: string[];
  taxRoles?: string[];
  censusRoles?: string[];
  permitRoles?: string[];
  propertyMgmtRoles?: string[];
  realEstateRoles?: string[];
  logisticsRoles?: string[];
  tourismRoles?: string[];
  educationRoles?: string[];
  healthRoles?: string[];
  socialServicesRoles?: string[];
  businessRegistrationRoles?: string[];
  businessRegistrationAdminRoles?: string[];
  communityMappingRoles?: string[];
}

export function useUserRoles() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['user-roles', user?.id],
    queryFn: async () => {
      if (!user?.id) return [];

      const response = await getLiberiaCurrentUserRoles({
        user,
        role: null,
        hasAddressGenerationAccess: true,
      });

      return (response.roles || []) as UserRoleAccess[];
    },
    enabled: !!user?.id,
  });
}
